import { createSlice } from "@reduxjs/toolkit";

export const timezoneSlice = createSlice({
  name: "timezone",
  initialState: {
    getTimezoneResult: false,
    getTimezoneLoading: false,
    getTimezoneError: false,
  },
  reducers: {
    timezoneReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TIMEZONE":
          return {
            ...state,
            getTimezoneResult: payload.data,
            getTimezoneLoading: payload.loading,
            getTimezoneError: payload.error,
          };
        default:
          return state;
      }
    },
  },
});

export const { timezoneReducers } = timezoneSlice.actions;

export default timezoneSlice.reducer;
